import { render, staticRenderFns } from "./SpaceManagerBaseModal.vue?vue&type=template&id=32f1c122&scoped=true"
import script from "./SpaceManagerBaseModal.vue?vue&type=script&lang=js"
export * from "./SpaceManagerBaseModal.vue?vue&type=script&lang=js"
import style0 from "./SpaceManagerBaseModal.vue?vue&type=style&index=0&id=32f1c122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1c122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
